function artSizeDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/art-size/art-size-dialog.html'
  }
}

export { artSizeDialog }
